__turbopack_context__.v({
  "button": "sso-button-module-scss-module__4JSImW__button",
  "container": "sso-button-module-scss-module__4JSImW__container",
  "icon": "sso-button-module-scss-module__4JSImW__icon",
});
